/* CODEX_OUTLET_LIVE_CDN_PURGE_1783640663956 */
"use strict";

(() => {
  const outletUrl = new URL(window.location.href);
  if (/\/collections\/outlet\/?$/.test(outletUrl.pathname) && outletUrl.searchParams.get("view") === "outlet-live-nocontext-20260710") {
    outletUrl.searchParams.delete("view");
    window.history.replaceState(window.history.state, "", outletUrl.pathname + outletUrl.search + outletUrl.hash);
  }

  const productTagLayoutStyleId = "codex-product-tag-layout-runtime";

  function injectProductTagLayoutStyle() {
    let style = document.getElementById(productTagLayoutStyleId);
    if (!style) {
      style = document.createElement("style");
      style.id = productTagLayoutStyleId;
    }
    style.textContent = [
      ".callout .card__information--with-label{grid-template-columns:minmax(0,1fr)!important;gap:10px!important}",
      ".callout .card-information,.callout .card__information .card__colors-info,.callout .card__tag-wrapper{grid-column:1!important;grid-row:auto!important;width:100%!important}",
      ".callout .card__content .card__information--with-label .card__tag-wrapper{display:flex!important;flex-direction:row!important;flex-wrap:wrap!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important}",
      ".outlet .card__information--with-label{grid-template-columns:minmax(0,1fr) minmax(118px,auto)!important;column-gap:14px!important;row-gap:11px!important;align-items:start!important}",
      ".outlet .card__information--with-label>.card__heading{grid-column:1!important;grid-row:1!important;align-self:start!important;min-width:0!important;margin:0!important}",
      ".outlet .card__information--with-label>.card-information{grid-column:2!important;grid-row:1!important;justify-self:end!important;align-self:start!important;width:auto!important;min-width:0!important;text-align:right!important}",
      "html body .outlet.outlet .outlet__wrapper .outlet__group-rows .card-wrapper.card-wrapper:not(.article-card-wrapper) .card__content .card__information--with-label .card__tag-wrapper.card__tag-wrapper{display:flex!important;flex-flow:row wrap!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important;grid-area:auto / 1 / auto / -1!important;justify-self:stretch!important;align-self:start!important;width:var(--outlet-card-width,100%)!important;max-width:none!important}",
      ".outlet .card__information--with-label>.outlet__variant-swatches,.outlet .card__information--with-label>.outlet__head-fit{grid-area:auto / 1 / auto / -1!important;justify-self:stretch!important;align-self:start!important;width:var(--outlet-card-width,100%)!important;max-width:none!important}",
      ".outlet .card__tag-wrapper modal-opener,.outlet .card__tag-wrapper .card__tag{flex:0 0 auto!important;width:auto!important;max-width:100%!important}"
    ].join("");
    document.head.appendChild(style);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", injectProductTagLayoutStyle);
  } else {
    injectProductTagLayoutStyle();
  }


  /* CODEX_OUTLET_PIP_LOOP_HANDLER_20260626 */
  function parseOutletPipList(button) {
    try {
      const items = JSON.parse(button.dataset.calloutPipList || "[]");
      return Array.isArray(items) ? items.filter((item) => {
        return item?.pip?.src && item?.main?.src && item?.main?.srcset;
      }) : [];
    } catch (error) {
      console.warn("Outlet PIP list parse skipped", error);
      return [];
    }
  }

  function setOutletImage(image, payload) {
    if (!image || !payload?.src) return;
    if (payload.srcset) image.srcset = payload.srcset;
    else image.removeAttribute("srcset");
    image.src = payload.src;
    if (payload.width) image.width = payload.width;
    if (payload.height) image.height = payload.height;
    image.alt = payload.alt || "";
  }

  function handleOutletPipLoop(event) {
    const button = event.target?.closest?.('.outlet button.callout-pip[data-callout-pip="variant"]');
    if (!button) return;

    const card = button.closest(".card-js");
    const mainImage = card?.querySelector(".media > img.active");
    const pipImage = button.querySelector("img");
    const items = parseOutletPipList(button);
    if (!card || !mainImage || !pipImage || items.length < 2) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const currentIndex = Number(button.dataset.calloutPipIndex || "0");
    const safeIndex = Number.isFinite(currentIndex) && currentIndex >= 0 ? currentIndex % items.length : 0;
    const nextIndex = (safeIndex + 1) % items.length;
    setOutletImage(mainImage, items[safeIndex].main);
    setOutletImage(pipImage, items[nextIndex].pip);
    button.dataset.calloutPipIndex = String(nextIndex);
  }

  document.addEventListener("click", handleOutletPipLoop, true);


  /* CODEX_OUTLET_PRODUCT_CALLOUT_ROWS_20260708 */
  const OUTLET_HEAD_SHAPE_ORDER = ["standard_small", "standard", "standard_wide", "wide_fit"];

  const escapeOutletHtml = (value) => String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

  Alpine.data("outlet", () => ({
    productsCount: 0,
    allProducts: [],
    loading: false,
    activeFilter: "all",
    sourceSynced: false,
    selectedByGroup: {},
    fitI18n: null,
    rowTargets: null,

    init() {
      this.allProducts = Array.from(this.$el.querySelectorAll(".outlet__items-grid li[data-outlet-variant-id]"));
      this.ensureRows();
      this.fitI18n = this.readFitI18n();
      this.applyFilter(true);
      this.syncSourceProducts();
    },

    readFitI18n() {
      try {
        return JSON.parse(this.$el.querySelector("[data-outlet-fit-i18n]")?.textContent || "{}");
      } catch (error) {
        console.warn("Outlet fit labels parse skipped", error);
        return {};
      }
    },

    onSelectChange(event) {
      this.activeFilter = event?.target?.value || "all";
      this.applyFilter(true);
    },

    getGroupKey(item) {
      return item?.dataset?.outletGroupKey || item?.dataset?.outletVariantId || "";
    },

    isItemAvailable(item) {
      const matchesSource = item.dataset.sourceMatched !== "false";
      const matchesFilter = this.activeFilter === "all" || item.dataset.filterOption === this.activeFilter;
      return matchesSource && matchesFilter;
    },

    isItemSoldOut(item) {
      const text = (item.textContent || "").toLowerCase();
      const button = item.querySelector('button[name="add"], .quick-add__submit, form[action*="/cart/add"] button[type="submit"]');
      return Boolean(button?.disabled) || text.includes("sold out");
    },

    itemTitle(item) {
      return String(item?.querySelector?.(".card__heading")?.textContent || item?.dataset?.filterOption || "").toLowerCase();
    },

    itemRowGroup(item) {
      const rowKey = String(item?.dataset?.outletRowKey || "").toLowerCase();
      if (rowKey === "basic-tvo" || rowKey === "basic-tvo-pro") return "basic";
      return "feature";
    },

    itemDisplayOrder(item) {
      const title = this.itemTitle(item);
      const sku = String(item?.dataset?.outletSwatchLabel || "").toUpperCase();
      const family = String(item?.dataset?.outletFamilyKey || "").toLowerCase();
      const rowKey = String(item?.dataset?.outletRowKey || "").toLowerCase();

      if (this.itemRowGroup(item) === "basic") {
        if (title.includes("cogs") && family === "tvo") return 10;
        if ((title.includes("ovo") || title.includes("oval")) && family === "tvo") return 20;
        if (title.includes("cogs") && family === "tvo_pro") return 30;
        if ((title.includes("ovo") || title.includes("oval")) && family === "tvo_pro") return 40;
      }

      if (rowKey === "gcm" || title.includes("gold coast") || title.includes("marathon") || sku.includes("GCM")) return 0;
      if (title.includes("fancy")) return 10;
      if (title.includes("halo")) return 20;
      if (title.includes("cogs")) return 30;
      if (title.includes("ovo") || title.includes("oval")) return 40;

      const value = Number(item?.dataset?.outletProductOrder);
      return Number.isFinite(value) ? value : 999;
    },

    groupSort(a, b) {
      const aItem = a[1][0];
      const bItem = b[1][0];
      const numeric = (item, key, fallback = 999) => {
        const value = Number(item?.dataset?.[key]);
        return Number.isFinite(value) ? value : fallback;
      };
      const rowOrder = (item) => this.itemRowGroup(item) === "basic" ? 10 : 20;
      return (
        rowOrder(aItem) - rowOrder(bItem) ||
        this.itemDisplayOrder(aItem) - this.itemDisplayOrder(bItem) ||
        numeric(aItem, "outletFamilyOrder") - numeric(bItem, "outletFamilyOrder") ||
        String(aItem?.dataset?.filterOption || "").localeCompare(String(bItem?.dataset?.filterOption || ""))
      );
    },

    ensureRows() {
      if (this.rowTargets?.source) return this.rowTargets;

      const productRoot = this.$el.querySelector("#outlet-products") || this.$el;
      const source = productRoot.querySelector(".outlet__items-grid");
      if (!source) return { source: null, basic: null, feature: null };

      source.classList.add("outlet__items-grid--source");
      source.dataset.outletSourceGrid = "true";

      let shell = productRoot.querySelector("[data-outlet-group-rows]");
      if (!shell) {
        shell = document.createElement("div");
        shell.className = "outlet__group-rows";
        shell.dataset.outletGroupRows = "true";

        ["basic", "feature"].forEach((key) => {
          const wrap = document.createElement("div");
          wrap.className = "outlet__grid-wrap";
          wrap.dataset.outletRowWrap = key;
          const row = document.createElement("ul");
          row.className = "outlet__items-grid outlet__items-grid--row";
          row.dataset.outletRowTarget = key;
          wrap.append(row);
          shell.append(wrap);
        });

        productRoot.insertBefore(shell, source);
      }

      this.rowTargets = {
        source,
        basic: shell.querySelector('[data-outlet-row-target="basic"]'),
        feature: shell.querySelector('[data-outlet-row-target="feature"]'),
      };
      return this.rowTargets;
    },

    resetRenderedGroups() {
      const rows = this.ensureRows();
      this.allProducts.forEach((item) => {
        item.classList.remove("active");
        item.classList.add("hidden", "outlet__group-member--hidden");
        delete item.dataset.outletGroupActive;
        item.querySelectorAll(".outlet__variant-swatches, .outlet__head-fit").forEach((node) => node.remove());
        rows.source?.appendChild(item);
      });
    },

    applyFilter(resetScroll = false) {
      this.productsCount = 0;
      this.resetRenderedGroups();

      const groups = new Map();
      this.allProducts.forEach((item) => {
        if (!this.isItemAvailable(item)) return;
        const groupKey = this.getGroupKey(item);
        if (!groupKey) return;
        if (!groups.has(groupKey)) groups.set(groupKey, []);
        groups.get(groupKey).push(item);
      });

      const rows = this.ensureRows();
      [rows.basic, rows.feature].forEach((row) => {
        if (!row) return;
        row.textContent = "";
      });

      Array.from(groups.entries()).sort((a, b) => this.groupSort(a, b)).forEach(([groupKey, items]) => {
        const selectedId = this.selectedByGroup[groupKey];
        const selectedItem = items.find((item) => item.dataset.outletVariantId === selectedId)
          || items.find((item) => !this.isItemSoldOut(item))
          || items[0];

        selectedItem.classList.add("active");
        selectedItem.classList.remove("hidden", "outlet__group-member--hidden");
        selectedItem.dataset.outletGroupActive = "true";
        const targetRow = rows[this.itemRowGroup(selectedItem)] || rows.feature || rows.source;
        targetRow?.appendChild(selectedItem);

        this.renderGroupSwatches(selectedItem, items, selectedItem.dataset.outletVariantId, groupKey);
        this.renderHeadFit(selectedItem);
        this.productsCount += 1;
      });

      this.allProducts
        .filter((item) => !item.dataset.outletGroupActive)
        .forEach((item) => rows.source?.appendChild(item));

      if (resetScroll) {
        requestAnimationFrame(() => {
          [rows.basic, rows.feature].forEach((row) => {
            if (row) row.closest(".outlet__grid-wrap")?.scrollTo({ left: 0, top: 0, behavior: "instant" });
          });
        });
      }
    },

    /* CODEX_OUTLET_SWATCH_SCROLL_ANCHOR_20260709 */
    /* CODEX_OUTLET_SWATCH_POINTER_SNAP_SETTLE_20260710 */
    restoreRowPosition(anchor){/* CODEX_OUTLET_VISUAL_ANCHOR_20260712 */if(!anchor)return;const rows=this.ensureRows(),row=rows[anchor.rowKey]||rows.feature||rows.basic,wrap=row?.closest(".outlet__grid-wrap");if(!row||!wrap)return;const target=Array.from(row.querySelectorAll("li[data-outlet-variant-id]")).find(item=>this.getGroupKey(item)===anchor.groupKey),fallbackLeft=Math.max(0,Number(anchor.scrollLeft||0)),anchorCardLeft=Number(anchor.cardLeft),currentCardLeft=target?Number(target.getBoundingClientRect().left):NaN,currentScrollLeft=Math.max(0,Number(wrap.scrollLeft||0)),visualTarget=Number.isFinite(anchorCardLeft)&&Number.isFinite(currentCardLeft)?currentScrollLeft+(currentCardLeft-anchorCardLeft):fallbackLeft,maxLeft=Math.max(0,wrap.scrollWidth-wrap.clientWidth),targetLeft=Math.min(maxLeft,Math.max(0,Number.isFinite(visualTarget)?visualTarget:fallbackLeft)),previousInlineSnap=wrap.style.scrollSnapType,releaseDelay=560,restore=()=>{wrap.style.scrollSnapType="none",wrap.scrollTo({left:targetLeft,top:0,behavior:"instant"})},release=()=>{wrap.scrollTo({left:targetLeft,top:0,behavior:"instant"}),wrap.style.scrollSnapType=previousInlineSnap||""};restore(),requestAnimationFrame(()=>{restore(),requestAnimationFrame(restore)}),window.setTimeout(restore,60),window.setTimeout(restore,160),window.setTimeout(restore,320),window.setTimeout(release,releaseDelay)},renderGroupSwatches(hostItem, groupItems, selectedId, groupKey) {
      if (!hostItem || groupItems.length < 2) return;

      const container = document.createElement("div");
      container.className = "swatches outlet__variant-swatches";
      container.setAttribute("role", "list");

      groupItems.forEach((item) => {
        const button = document.createElement("button");
        const variantId = item.dataset.outletVariantId || "";
        const isSelected = variantId === selectedId;
        const title = item.dataset.outletSwatchTitle || item.dataset.outletSwatchLabel || "Select colour";
        button.type = "button";
        button.className = "swatch-wrapper" + (isSelected ? " active" : "");
        button.dataset.outletGroupSwatch = "true";
        button.dataset.outletGroupKey = groupKey;
        button.dataset.outletVariantId = variantId;
        button.dataset.frameColor = item.dataset.outletSwatchFrame || "#111111";
        button.dataset.lensesColor = item.dataset.outletSwatchLens || button.dataset.frameColor || "#d9d9d9";
        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
        button.setAttribute("aria-label", title);
        button.title = title;

        const swatch = document.createElement("div");
        swatch.className = "swatch double";
        const frame = document.createElement("span");
        const lens = document.createElement("span");
        const frameColor = item.dataset.outletSwatchFrame || "#111111";
        const lensColor = item.dataset.outletSwatchLens || frameColor || "#d9d9d9";
        frame.style.background = frameColor;
        lens.style.background = lensColor;
        if (this.needsOutline(frameColor)) frame.classList.add("outline");
        if (this.needsOutline(lensColor)) lens.classList.add("outline");
        swatch.append(frame, lens);
        button.append(swatch);

        button.addEventListener("pointerdown", (event) => {
          event.stopPropagation();
          const wrap = hostItem.closest(".outlet__grid-wrap");
          button.dataset.outletAnchorScrollLeft = String(wrap ? wrap.scrollLeft : 0);
        }, { passive: true });

        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (event.currentTarget && typeof event.currentTarget.blur === "function") event.currentTarget.blur();
          const wrap = hostItem.closest(".outlet__grid-wrap");
          const anchor={groupKey,rowKey:this.itemRowGroup(hostItem),scrollLeft:wrap?Number(button.dataset.outletAnchorScrollLeft||wrap.scrollLeft||0):0,cardLeft:hostItem.getBoundingClientRect().left};
          this.selectedByGroup[groupKey] = variantId;
          this.applyFilter(false);
          this.restoreRowPosition(anchor);
        });

        container.append(button);
      });

      const cardInfo = hostItem.querySelector(".card__information--with-label")
        || hostItem.querySelector(".card__information")
        || hostItem;
      const tagWrapper = hostItem.querySelector(".card__tag-wrapper");
      if (tagWrapper?.parentNode) tagWrapper.insertAdjacentElement("afterend", container);
      else cardInfo.append(container);
    },

    activeHeadShapes(fitLabel) {
      const text = String(fitLabel || "").toLowerCase();
      if (!text) return ["standard_small", "standard", "standard_wide"];
      if (text.includes("flexible")) return [...OUTLET_HEAD_SHAPE_ORDER];
      if (text.includes("smaller") || text.includes("small")) return ["standard_small", "standard"];
      if (text.includes("normal") && text.includes("larger")) return ["standard", "standard_wide", "wide_fit"];
      if (text.includes("larger") || text.includes("large")) return ["standard_wide", "wide_fit"];
      if (text.includes("normal")) return ["standard_small", "standard", "standard_wide"];
      return ["standard_small", "standard", "standard_wide"];
    },

    renderHeadFit(hostItem) {
      if (!hostItem) return;
      const labels = this.fitI18n?.fitOptions || {};
      const activeShapes = new Set(this.activeHeadShapes(hostItem.dataset.outletFitKey));
      const title = this.fitI18n?.fitSystemLabel || "Head fit";
      const activeText = OUTLET_HEAD_SHAPE_ORDER
        .filter((key) => activeShapes.has(key))
        .map((key) => labels[key] || key)
        .join(", ");
      const fitHandle = String(hostItem.dataset.outletFitKey || "").trim().toLowerCase().replace(/\s*-\s*/g, "-");
      const modalId = (this.$el.closest("[data-outlet-fit-prefix]")?.dataset.outletFitPrefix || "") + fitHandle;
      const modal = document.getElementById(modalId);
      const holder = document.createElement("div");
      holder.className = "outlet__head-fit";
      holder.setAttribute("aria-label", title + ": " + activeText);
      holder.innerHTML = [
        '<span class="outlet__head-fit-title">' + escapeOutletHtml(title) + '</span>',
        '<span class="outlet__head-fit-options">',
        OUTLET_HEAD_SHAPE_ORDER.map((key) => (
          '<span class="outlet__head-option outlet__head-option--' + key.replace(/_/g, "-") + (activeShapes.has(key) ? " outlet__head-option--active" : "") + '" aria-label="' + escapeOutletHtml(labels[key] || key) + '">' +
            '<span class="outlet__head-icon" aria-hidden="true"></span>' +
            '<span class="outlet__head-label">' + escapeOutletHtml(labels[key] || key) + '</span>' +
          '</span>'
        )).join(""),
        '</span>',
      ].join("");

      if (modal) {
        const options = holder.querySelector(".outlet__head-fit-options");
        const button = document.createElement("button");
        button.type = "button";
        button.className = options.className;
        button.innerHTML = options.innerHTML;
        button.setAttribute("aria-label", title + ": " + activeText);
        button.setAttribute("aria-haspopup", "dialog");
        button.setAttribute("aria-controls", modalId);
        button.addEventListener("click", () => modal.show(button));
        options.replaceWith(button);
      }

      const cardInfo = hostItem.querySelector(".card__information--with-label")
        || hostItem.querySelector(".card__information")
        || hostItem;
      const swatches = hostItem.querySelector(".outlet__variant-swatches");
      if (swatches?.parentNode) swatches.insertAdjacentElement("afterend", holder);
      else cardInfo.append(holder);
    },

    needsOutline(color) {
      const value = String(color || "").trim().toLowerCase();
      return value === "#fff" || value === "#ffffff" || value === "white" || value === "rgb(255, 255, 255)";
    },

    updateFilterOptions() {
      const select = this.$el.querySelector("#outlet-filters");
      if (!select) return;

      const availableFilters = new Set(
        this.allProducts
          .filter((item) => item.dataset.sourceMatched !== "false")
          .map((item) => item.dataset.filterOption)
          .filter(Boolean)
      );

      Array.from(select.options).forEach((option) => {
        if (option.value === "all") return;

        const isAvailable = availableFilters.has(option.value);
        option.hidden = !isAvailable;
        option.disabled = !isAvailable;
      });

      if (select.selectedOptions[0]?.disabled) {
        select.value = "all";
        this.activeFilter = "all";
      }
    },

    async syncSourceProducts() {
      const section = this.$el.closest(".outlet");
      if (!section || section.dataset.outletSourceSync !== "true" || !section.dataset.outletSourceUrl) {
        this.sourceSynced = true;
        return;
      }

      this.loading = true;

      try {
        const response = await fetch(section.dataset.outletSourceUrl, { credentials: "same-origin" });
        if (!response.ok) throw new Error("Outlet source request failed: " + response.status);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const sourceIds = new Set(
          Array.from(doc.querySelectorAll(".outlet__items-grid li[data-outlet-variant-id]"))
            .map((item) => item.dataset.outletVariantId)
            .filter(Boolean)
        );

        if (sourceIds.size > 0) {
          this.allProducts.forEach((item) => {
            item.dataset.sourceMatched = sourceIds.has(item.dataset.outletVariantId) ? "true" : "false";
          });
        }
      } catch (error) {
        console.warn("Outlet source sync skipped", error);
      } finally {
        this.sourceSynced = true;
        this.loading = false;
        this.updateFilterOptions();
        this.applyFilter(true);
      }
    },
  }));
})();
